import { Box, Button, ButtonProps, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { IcAddress, IcEstimatedTime, IcWorkOrder } from 'res/icons';
import Order from '../../../../models/Order';

interface WorkOrderItemProps {
	workOrder: Order;
}

function convertDecimalToTime(decimalHours: number) {
	const hours = Math.floor(decimalHours);
	const minutes = Math.round((decimalHours - hours) * 60);

	let result = '';

	if (decimalHours === 0) {
		result = '0 Hour';
		return result;
	}

	if (hours > 0) {
		result += `${hours} hour${hours !== 1 ? 's' : ''}`;
	}

	if (minutes > 0) {
		if (hours > 0) result += ' ';
		result += `${minutes} minute${minutes !== 1 ? 's' : ''}`;
	}

	return result;
}

const WorkOrderItem = styled(({ workOrder, ...props }: ButtonProps & WorkOrderItemProps) => {
	return (
		<Button style={{ height: 80 }} disableRipple disableFocusRipple disableTouchRipple fullWidth {...props}>
			<Box>
				<Box alignItems={'center'} className="desc">
					<IcWorkOrder style={{ color: workOrder.phase ? workOrder.phase.color : '#0859A4' }} />
					&nbsp;&nbsp;
					<Typography sx={{ textTransform: 'none' }} variant="body2">
						WO: <span>{workOrder.orderNo}</span>
					</Typography>
				</Box>
				<Box alignItems={'center'} className="desc" minHeight={'auto'}>
					<IcAddress />
					&nbsp;&nbsp;
					<Typography sx={{ textTransform: 'none' }} variant="body2">
						<span>{workOrder.address ? workOrder.address.line1 : ''}</span>
					</Typography>
				</Box>
				<Box alignItems={'center'} className="desc">
					<IcEstimatedTime />
					&nbsp;&nbsp;
					<Typography sx={{ textTransform: 'none' }} variant="body2">
						EPT: <span>{convertDecimalToTime(workOrder.estimatedHours)}</span>
					</Typography>
				</Box>
			</Box>
		</Button>
	);
})(() => ({
	flexWrap: 'wrap',
	height: '100%',
	borderRadius: 0,
	userSelect: 'none',
	justifyContent: 'flex-start',
	padding: '0px 10px',
	color: '#000000',
	backgroundColor: '#f5f8fb',
	border: '1px solid transparent',
	'&:hover': {
		border: '1px solid #0859a4',
		backgroundColor: 'inherit',
		transition: 'border ease .3s',
		userSelect: 'none',
		cursor: 'pointer',
	},
	'& .desc': {
		minHeight: 20,
		// padding: '2px 0',
		display: 'flex',
		'& > svg': {
			width: 10,
			minWidth: 10,
		},
		'& > p': {
			fontSize: '11px',
			'& > span': {
				color: '#0859a4',
			},
		},
	},
}));

export default WorkOrderItem;
